import { useEffect, useState, useCallback } from 'react'
import { useSessionContext } from '../contexts/SessionContext'
import {
  getUserOwnedExperiences,
  getUserOwnedExperiencesWithoutDefault,
} from '../utils/helpers/supabase.helpers'
import { AgamiExperience } from '../types/supabase'

interface UseUserExperiencesOptions {
  enabled?: boolean
  excludeDefaultExperience?: boolean
}

interface UseUserExperiencesReturn {
  experienceList: AgamiExperience[] | null
  isLoading: boolean
  refetch: () => Promise<void>
}

export const useUserExperiences = (options: UseUserExperiencesOptions = {}): UseUserExperiencesReturn => {
  const { user } = useSessionContext()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [experienceList, setExperienceList] = useState<AgamiExperience[] | null>(null)
  const { enabled = true, excludeDefaultExperience } = options

  const fetchExpList = useCallback(async (): Promise<void> => {
    if (enabled === false) {
      return
    }

    const { data, error } = excludeDefaultExperience
      ? await getUserOwnedExperiencesWithoutDefault({ userId: user!.id })
      : await getUserOwnedExperiences({ userId: user!.id })

    if (error || !data) {
      setIsLoading(false)
      return
    }

    setExperienceList(data)
    setIsLoading(false)
  }, [user, enabled, excludeDefaultExperience])

  useEffect(() => {
    if (!user || enabled === false) {
      return
    }

    fetchExpList()
  }, [user, enabled, fetchExpList])

  return { experienceList, isLoading, refetch: fetchExpList }
}
